import { useApp } from '../app-context';

// Win/lose reveal card (best-practice §11.7). Generic over anime/character.
export default function VictoryCard({
  won,
  image,
  title,
  meta,
  sub,
}: {
  won: boolean;
  image: string | null;
  title: string;
  meta: string;
  sub: string;
}) {
  const { t } = useApp();
  return (
    <section className={`victory ${won ? '' : 'lost'}`}>
      <div className="bang">{won ? `クリア!! ${t('victory.won')}` : `おしい！ ${t('victory.lost')}`}</div>
      <div className="ans">
        {image && <img src={image} alt={title} />}
        <div className="t">
          <b>{title}</b>
          <span>{meta}</span>
          <span>{sub}</span>
        </div>
      </div>
    </section>
  );
}
